import { ListingsFiltersMatchCriteriaKey } from '@aloft/toolkit-shared/lib/api/listings/types';

import { useWatch } from 'react-hook-form';
import { useZodFormContext } from '../../../../hooks/useZodForm.ts';
import { AreaRangeInputs } from '../../../FilterDrawer/AreaRangeInputs.tsx';
import { DateRangeInputs } from '../../../FilterDrawer/DateRangeInputs.tsx';
import { MinMaxInputs } from '../../../FilterDrawer/MinMaxInputs.tsx';
import { NumberInput } from '../../../FilterDrawer/NumberInput.tsx';
import { NumberRangeInput } from '../../../FilterDrawer/NumberRangeInput.tsx';
import { PercentageInput } from '../../../FilterDrawer/PercentageInput.tsx';
import { PriceRangeInputs } from '../../../FilterDrawer/PriceRangeInputs.tsx';
import { RecommendCompsFormSchema } from '../../types.ts';

export const FilterInputFields = ({
  name,
  type,
  unitName,
}: {
  name: ListingsFiltersMatchCriteriaKey;
  type: 'unit' | 'date' | 'price' | 'area';
  unitName?: string;
}) => {
  const { control } = useZodFormContext<RecommendCompsFormSchema>();
  const selectedMatchCriteria = useWatch({ name: `search.matchCriteria.${name}`, control });

  switch (selectedMatchCriteria) {
    case 'min_max_range':
      switch (type) {
        case 'date':
          return (
            <DateRangeInputs
              minName={`search.filters.${name}.min`}
              maxName={`search.filters.${name}.max`}
            />
          );
        case 'price':
          return (
            <PriceRangeInputs
              minName={`search.filters.${name}.min`}
              maxName={`search.filters.${name}.max`}
            />
          );
        case 'area':
          return (
            <AreaRangeInputs
              minName={`search.filters.${name}.min`}
              maxName={`search.filters.${name}.max`}
            />
          );
        case 'unit':
          return (
            <MinMaxInputs
              minName={`search.filters.${name}.min`}
              maxName={`search.filters.${name}.max`}
            />
          );
        default:
          return null;
      }
    case 'exact':
      return <NumberInput name={`search.filters.${name}.exact`} />;

    case 'percentage_range':
      return <PercentageInput name={`search.filters.${name}.percentage`} />;

    case 'value_range':
      return <NumberRangeInput name={`search.filters.${name}.variance`} suffix={unitName} />;

    case 'lasting_range':
      switch (type) {
        case 'date':
          return <NumberInput name={`search.filters.${name}.variance`} suffix={unitName} />;
        default:
          return null;
      }
    default:
      return null;
  }
};
